'use strict';

var values = require('object.values');

if (!Object.values) {
  values.shim();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toastify/lib/ObjectValuesPolyfill.js
// module id = 537
// module chunks = 0